import React, { useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AppContext } from '@/store';
import { clearJumplinks } from '@/store/jumplinks/actions';

const StateComponent = () => {
  const location = useLocation();
  const { dispatch } = useContext(AppContext);

  useEffect(() => {
    dispatch(clearJumplinks());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return <></>;
};

export default StateComponent;
